/**
 * Column configuration of the desktop check-inventory batch table
 * (`../CheckInventoryModalDesktop.tsx`): batch number, quantity available in the selected quantity
 * UOM, and that quantity in pounds. The mobile view lays out the same three columns itself
 * (`../CheckInventoryHelper.tsx` → `renderMobileBatchData`).
 */
import { ColumnConfig } from "@ryerson/frontend.table";
import { Product, getDisplayUom } from "@ryerson/frontend.common";
import { lbs } from "@ryerson/common.uom";
import CheckInventoryModalTableColumnHeader from "./CheckInventoryModalTableColumnHeader";
import CheckInventoryModalTableBatchNumberCell from "./CheckInventoryModalTableBatchNumberCell";
import CheckInventoryModalTableQtyAvailableCell from "./CheckInventoryModalTableQtyAvailableCell";
import CheckInventoryModalTableQtyAvailableInPound from "./CheckInventoryModalTableQtyAvailableInPound";

/**
 * Builds the three batch-table columns for the current UOMs and product. `fetching` makes the
 * quantity cells show "Loading...". The desktop view memoises the result on these four arguments.
 */
export const getCheckInventoryModalTableConfiguration = (
	// generally we want to avoid passing args to table config functions for column renders, but doing so here to avoid major refactoring
	qtyUom: string,
	priceUom: string,
	product: Product,
	fetching: boolean
): ColumnConfig[] => {
	return [
		{
			id: "batchNumber",
			label: "",
			headerRender: () => (
				<CheckInventoryModalTableColumnHeader {...{ contentKey: "batch" }} />
			),
			cellRender: ({ itemData }) => (
				<CheckInventoryModalTableBatchNumberCell {...{ itemData }} />
			),
		},
		{
			id: "quantityAvailable",
			label: "",
			headerRender: () => (
				<CheckInventoryModalTableColumnHeader
					{...{
						headerTitle: getDisplayUom(product?.form, qtyUom || lbs.value, "quantity"),
					}}
				/>
			),
			cellRender: ({ rowData }) => (
				<CheckInventoryModalTableQtyAvailableCell {...{ rowData, fetching }} />
			),
		},
		{
			id: "quantityAvailableInPound",
			label: "",
			headerRender: () => (
				<CheckInventoryModalTableColumnHeader {...{ contentKey: "available" }} />
			),
			cellRender: ({ rowData }) => (
				<CheckInventoryModalTableQtyAvailableInPound
					{...{ rowData, qtyUom, product, priceUom }}
				/>
			),
		},
	];
};
